import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ICountry } from '@/shared/model/countries.model';

const baseApiSettings = 'api/public/settings/countries';
const baseApiUrl = 'api/country';

export default class CountryService {
  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiSettings).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(iso: string): Promise<ICountry> {
    return new Promise<ICountry>(resolve => {
      axios.get(`${baseApiUrl}/${iso}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public create(entity: ICountry): Promise<ICountry> {
    return new Promise<ICountry>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: ICountry): Promise<ICountry> {
    return new Promise<ICountry>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public delete(iso: string): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${iso}`).then(function(res) {
        resolve(res);
      });
    });
  }
}
